let mutations = {
    UPDATE_SONGS(state, songs) {
        state.songs.splice(0, songs.length);
        songs.forEach((song)=> {
            state.songs.push(song);
        })
    },
    UPDATE_TOOLTIP(state, value) {
        state.tooltip = value;
    }
};
export default mutations;